module.exports = __webpack_public_path__ + "static/media/gutech-jobs.e27b8ee2.png";